import type { LeaveGridEvent } from 'modules/shift_management/utils/TimeGridTable/transformEvents'

import type { EventCardSpec } from 'modules/shift_management/utils/TimeGridTable/resolveCard'

const LeaveCard: EventCardSpec<LeaveGridEvent> = {
  getAppearance: () => ({
    background: 'purple200',
    opacity: '0.9',
    border: { all: { width: 's1', style: 'solid', color: 'champagne200' } },
    fillHeight: true,
  }),
  render: (event) => (event.leave.halfDay ? `½ ${event.leave.typeName}` : event.leave.typeName),
}

export { LeaveCard }
